import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function CustomerProtectionPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Banner */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-[#1A3A52]">
        <div className="max-w-4xl mx-auto text-center">
          <nav className="text-sm text-white/60 mb-4">
            <span>Home</span> <span className="mx-2">/</span> <span className="text-white">Customer Protection</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Customer Protection & Complaints
          </h1>
          <p className="text-lg text-white/80">
            Your rights and our commitment to fair treatment
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto space-y-12">
          {/* Commitment Section */}
          <div>
            <h2 className="text-3xl font-bold text-[#1A3A52] mb-6">
              Our Commitment to You
            </h2>
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-4">
                At Nakhalat Finance, we are committed to treating all our customers fairly, transparently, and with respect. Your financial wellbeing is our priority, and we uphold the highest standards of customer protection in all our operations.
              </p>
              <p className="text-gray-700 leading-relaxed">
                We believe in clear communication, honest dealings, and responsible lending practices. Every customer has the right to understand their loan terms, receive fair treatment, and have their concerns addressed promptly and professionally.
              </p>
            </div>
          </div>

          {/* How to Lodge a Complaint */}
          <div className="bg-[#E8EFF5] rounded-xl p-8">
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-6">
              How to Lodge a Complaint
            </h2>
            <div className="space-y-4">
              <p className="text-gray-700 leading-relaxed">
                If you have a concern or complaint about our services, we want to hear from you. You can lodge a complaint through any of the following channels:
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-phone-line text-[#1A3A52] mt-1"></i>
                  <div>
                    <strong className="text-[#1A3A52]">Phone:</strong>
                    <span className="text-gray-700 ml-2">Call our customer service line at +263 XXX XXXX</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-mail-line text-[#1A3A52] mt-1"></i>
                  <div>
                    <strong className="text-[#1A3A52]">Email:</strong>
                    <span className="text-gray-700 ml-2">complaints@nakhalatfinance.co.zw</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-building-line text-[#1A3A52] mt-1"></i>
                  <div>
                    <strong className="text-[#1A3A52]">In Person:</strong>
                    <span className="text-gray-700 ml-2">Visit our office in Harare during business hours</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-mail-send-line text-[#1A3A52] mt-1"></i>
                  <div>
                    <strong className="text-[#1A3A52]">Written Letter:</strong>
                    <span className="text-gray-700 ml-2">Send a formal complaint to our registered address</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Resolution Timeline */}
          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-6">
              Resolution Timeline
            </h2>
            <div className="space-y-4">
              <div className="flex gap-4 p-4 bg-white border border-gray-200 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A3A52] rounded-lg flex-shrink-0">
                  <span className="text-white font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A3A52] mb-1">Acknowledgment</h3>
                  <p className="text-gray-700 text-sm">We will acknowledge receipt of your complaint within 2 business days.</p>
                </div>
              </div>

              <div className="flex gap-4 p-4 bg-white border border-gray-200 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A3A52] rounded-lg flex-shrink-0">
                  <span className="text-white font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A3A52] mb-1">Investigation</h3>
                  <p className="text-gray-700 text-sm">We will thoroughly investigate your complaint and gather all relevant information.</p>
                </div>
              </div>

              <div className="flex gap-4 p-4 bg-white border border-gray-200 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A3A52] rounded-lg flex-shrink-0">
                  <span className="text-white font-bold">3</span>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A3A52] mb-1">Resolution</h3>
                  <p className="text-gray-700 text-sm">We aim to resolve all complaints within 14 business days of receipt.</p>
                </div>
              </div>

              <div className="flex gap-4 p-4 bg-white border border-gray-200 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A3A52] rounded-lg flex-shrink-0">
                  <span className="text-white font-bold">4</span>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A3A52] mb-1">Communication</h3>
                  <p className="text-gray-700 text-sm">You will receive a detailed response explaining our findings and any actions taken.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Escalation Process */}
          <div className="bg-white border-2 border-[#1A3A52] rounded-xl p-8">
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-6">
              Escalation Process
            </h2>
            <div className="space-y-4">
              <p className="text-gray-700 leading-relaxed">
                If you are not satisfied with our response or resolution, you have the right to escalate your complaint:
              </p>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <i className="ri-arrow-right-circle-line text-[#1A3A52] mt-1"></i>
                  <p className="text-gray-700">
                    <strong>Internal Escalation:</strong> Request to speak with our Complaints Manager or senior management team.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-arrow-right-circle-line text-[#1A3A52] mt-1"></i>
                  <p className="text-gray-700">
                    <strong>External Escalation:</strong> If your complaint remains unresolved after internal escalation, you have the right to approach the Reserve Bank of Zimbabwe.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* RBZ Contact */}
          <div className="bg-[#E8EFF5] rounded-xl p-8">
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-6">
              Reserve Bank of Zimbabwe Contact
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you believe your complaint has not been adequately addressed, you may contact the Reserve Bank of Zimbabwe:
            </p>
            <div className="space-y-2 text-gray-700">
              <p><strong>Address:</strong> 80 Samora Machel Avenue, Harare, Zimbabwe</p>
              <p><strong>Phone:</strong> +263 4 703000</p>
              <p><strong>Website:</strong> www.rbz.co.zw</p>
            </div>
          </div>

          {/* Commitment Statement */}
          <div className="text-center py-8">
            <p className="text-lg text-gray-700 leading-relaxed italic">
              "We value your feedback and are committed to continuous improvement. Every complaint is an opportunity for us to serve you better and uphold the trust you place in Nakhalat Finance."
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}